// Templates API helpers (Batch 41).
//
// Defensive response unwrapping (Feb 2026): on Capacitor iOS some interceptors
// or middleware wrappers can return `{data: [...]}` instead of the raw list.
// Normalise so the UI never sees an unexpectedly empty array.
import { api } from "@/lib/api";

function unwrapList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  if (data && Array.isArray(data.results)) return data.results;
  if (data && Array.isArray(data.items)) return data.items;
  return [];
}

export async function listTemplates({ kind, countryCode } = {}) {
  const params = {};
  if (kind) params.kind = kind;
  if (countryCode) params.country_code = countryCode;
  const { data } = await api.get("/templates", { params });
  const list = unwrapList(data);
  if (list.length === 0) {
    console.warn("[templatesApi] /templates returned empty — raw response:", data);
  }
  return list;
}

export async function listSubscriptions(familyId) {
  if (!familyId) return [];
  const { data } = await api.get(`/families/${familyId}/template-subscriptions`);
  return unwrapList(data);
}

export async function subscribeTemplate(familyId, templateId, { region, color } = {}) {
  const { data } = await api.post(
    `/families/${familyId}/template-subscriptions`,
    { template_id: templateId, region: region || null, color: color || null },
  );
  return data;
}

export async function refreshSubscription(familyId, subId) {
  const { data } = await api.post(
    `/families/${familyId}/template-subscriptions/${subId}/refresh`,
  );
  return data;
}

export async function unsubscribeTemplate(familyId, subId) {
  const { data } = await api.delete(
    `/families/${familyId}/template-subscriptions/${subId}`,
  );
  return data;
}

// ─── Country flag emoji helper ───
// ISO-3166 alpha-2 → regional indicator unicode pair. Works for almost all
// modern OS fonts. GB shows the Union Jack on iOS, generic banner on others.
export function flagEmoji(cc) {
  if (!cc || cc.length !== 2) return "🌐";
  const A = 127397; // 0x1F1A5 = 'A' (Regional Indicator) - 'A' (ASCII 65)
  return String.fromCodePoint(...cc.toUpperCase().split("").map((c) => c.charCodeAt(0) + A));
}

// ─── Local pref: remember the user's last-picked country across sessions ───
const LS_KEY = "kinly:templates:last-country";
export function getLastCountry() {
  try { return localStorage.getItem(LS_KEY); } catch { return null; }
}
export function setLastCountry(cc) {
  try { localStorage.setItem(LS_KEY, cc); } catch { /* ignore */ }
}
